// import {getCookie} from './getLoggedInCookie'

export const hasCredentials = () => {
    let token = localStorage.getItem("token");
    let role = JSON.parse(localStorage.getItem("roleId"));
    let userId = localStorage.getItem("userId");
    // let isLoggedIn = getCookie("isLoggedIn=true")
    return !!(token && role && userId);
  }
  